import * as React from 'react';

const PhoneIcon = () => (
  <svg width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Phone</title>
    <desc>Phone Icon</desc>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Calc-output---v7" transform="translate(-547.000000, -3553.000000)">
        <g id="Group-34" transform="translate(114.000000, 3400.000000)">
          <g id="what-next">
            <g id="Group-31" transform="translate(434.000000, 154.000000)">
              <g id="phone">
                <path d="M14.6255556,19.9538889 C16.4655556,23.57 19.43,26.5344444 23.0461111,28.3744444 L25.8572222,25.5633333 C26.215,25.2055556 26.7133333,25.1033333 27.1605556,25.2438889 C28.5916667,25.7166667 30.125,25.9722222 31.7222222,25.9722222 C32.4279194,25.9722222 33,26.5443028 33,27.25 L33,31.7222222 C33,32.4279194 32.4279194,33 31.7222222,33 C19.7253702,33 10,23.2746298 10,11.2777778 C10,10.93889 10.1346226,10.6138823 10.3742524,10.3742524 C10.6138823,10.1346226 10.93889,10 11.2777778,10 L15.75,10 C16.4556972,10 17.0277778,10.5720806 17.0277778,11.2777778 C17.0277778,12.875 17.2833333,14.4083333 17.7561111,15.8394444 C17.8966667,16.2866667 17.7944444,16.785 17.4366667,17.1427778 L14.6255556,19.9538889 Z" id="Shape" fill="#007788" fillRule="nonzero" transform="translate(21.500000, 21.500000) rotate(-360.000000) translate(-21.500000, -21.500000) " />
                <circle id="Oval-2" stroke="#007788" strokeWidth="2" cx="21.5" cy="21.5" r="21.5" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PhoneIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/PhoneIcon/PhoneIcon.tsx